module.exports = __webpack_public_path__ + "img/ideation-04-keyfeature-ico-03-grey.54e19146.svg";